import React from 'react';
import { useAllCompanies, CompanyOption } from '../hooks/useAllCompanies';

interface CompanySelectProps {
  value: number | null;
  onChange: (tenantId: number) => void;
  required?: boolean;
}

// Required company picker shown in an in-scope Create form only while SUPERADMIN is in
// "All Companies" mode (there is no tenant to infer the new record's company from).
// Its selected value is sent as `tenantId` in the create request body, consumed by
// authenticateToken's SUPERADMIN write guard (backend/middleware/auth.js).
const CompanySelect: React.FC<CompanySelectProps> = ({ value, onChange, required = true }) => {
  const { data, isLoading } = useAllCompanies();
  const companies: CompanyOption[] = data || [];
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5">Company</label>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(Number(e.target.value))}
        required={required}
        disabled={isLoading}
        className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-[16px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        <option value="" disabled>Select a company</option>
        {companies.map((c) => (
          <option key={c.tenantId} value={c.tenantId}>{c.name}</option>
        ))}
      </select>
    </div>
  );
};

export default CompanySelect;
